/* eslint-disable react/prop-types */
import React from 'react';

import { Button } from '@design-system-coopeuch/web';
import iconCIAnverso from '../../assets/img/icon-ci-anverso.svg';
import iconCIReverso from '../../assets/img/icon-ci-reverso.svg';

const ContentSerialNumber = (props) => {
  const { onClickButton } = props;
  return (
    <section className="p-7 m-0 d-flex flex-column">
      <article className="mt-3 mt-md-0 mb-2 d-flex justify-content-center align-items-center text-center">
        <h4>¿Dónde está el Nº de serie?</h4>
      </article>
      <article className="d-flex justify-content-center align-items-center flex-wrap">
        <article className="mr-0 mr-md-4 text-center">
          <h6>Cédula nueva</h6>
          <img src={iconCIAnverso} alt="cedula-anverso" height={150} width={256} />
        </article>
        <article className="text-center">
          <h6>Cédula antigua</h6>
          <img src={iconCIReverso} alt="cedula-anverso" height={150} width={256} />
        </article>
      </article>
      <article className="pt-7 d-flex justify-content-center align-items-center">
        <Button color="secondary" onClick={onClickButton} variant="default">
          Entendido
        </Button>
      </article>
    </section>
  );
}

export default ContentSerialNumber;
